import type { TimeOfDay } from '@roll1/shared';

export const TIME_OF_DAY_LABELS: Record<TimeOfDay, string> = {
  dawn: 'Рассвет',
  morning: 'Утро',
  midday: 'Полдень',
  afternoon: 'День',
  dusk: 'Закат',
  evening: 'Вечер',
  night: 'Ночь',
  midnight: 'Полночь',
};

/** Semi-transparent overlay colors for canvas ambient lighting */
export const TIME_OF_DAY_OVERLAY: Record<TimeOfDay, string> = {
  dawn: 'rgba(255, 183, 77, 0.12)',
  morning: 'rgba(255, 236, 179, 0.06)',
  midday: 'rgba(0, 0, 0, 0)',
  afternoon: 'rgba(255, 167, 38, 0.08)',
  dusk: 'rgba(255, 111, 0, 0.15)',
  evening: 'rgba(63, 81, 181, 0.2)',
  night: 'rgba(21, 34, 80, 0.35)',
  midnight: 'rgba(10, 15, 40, 0.45)',
};
